import { gql } from '@apollo/client';

export const GET_ME = gql`
query Membership {
  me {
    organisation {
      membership {
        isAdmin
        isTeacherPersona
        isCenterManager
        isCourseAdmin
      }
    }
  }
}`;
